import * as Yup from 'yup';
import strings from '../../localization';

const Validator = () =>
  Yup.object().shape({
    reason: Yup.string().required(strings.requiredField),
  });

export default Validator;
